<template>
  <div>
    <dashboard v-if="user && user.hasSectionFeature(AccountSectionFeaturesEnum.CORPORATE_DASHBOARD)" />
    <banking-dashboard v-if="user && user.hasSectionFeature(AccountSectionFeaturesEnum.BANKING_DASHBOARD)" />
  </div>
</template>

<script>

import AccountSectionFeaturesEnum from '@/api/enums/AccountSectionFeaturesEnum'
import Dashboard from '@/theme/default/views/dashboard/Dashboard.vue'
import BankingDashboard from '@/theme/default/views/banking/dashboard/BankingDashboard.vue'
export default {
  name      : 'DashboardWrapper',
  components: {
    Dashboard,
    BankingDashboard
  },
  enums: {
    AccountSectionFeaturesEnum
  },
  computed: {
    user () {
      return window.Vue?.user
    }
  }
}
</script>
